"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetFetchUserMFAStatus = exports.loadingFetchUserMFAStatus = exports.failureFetchUserMFAStatus = exports.successFetchUserMFAStatus = exports.fetchUserMFAStatus = exports.authenticateViaWebAuthN = exports.resetStartWebAuthnAuthentication = exports.loadingStartWebAuthnAuthentication = exports.failureStartWebAuthnAuthentication = exports.successStartWebAuthnAuthentication = exports.startWebAuthnAuthentication = exports.resetOTPAction = exports.getNewOTPAction = exports.resetSecretFileDownload = exports.getSecretFileDownloadAction = exports.resetGroupsDetails = exports.failureGroupsDetails = exports.successGroupsDetails = exports.loadingGroupsDetails = exports.resetUserDetails = exports.failureUserDetails = exports.successUserDetails = exports.loadingUserDetails = exports.failureSecretTemplateDetails = exports.successSecretTemplateDetails = exports.loadingSecretTemplateDetails = exports.requestSecretTemplateDetails = exports.updateSecretListSearchTerm = exports.failureSecretListLoadMore = exports.successSecretListLoadMore = exports.loadingSecretListLoadMore = exports.requestSecretListLoadMore = exports.resetSecretDetails = exports.failureSecretDetails = exports.successSecretDetails = exports.loadingSecretDetails = exports.requestSecretDetails = exports.flushStepUpMFA = exports.failureStepUpMFA = exports.successStepUpMFA = exports.requestAuthenticateStepUpMFA = exports.failureSecretList = exports.successSecretList = exports.loadingSecretList = exports.requestSecretList = void 0;

var _commonConstants = require("../../../../../../utils/common-constants");

var _constants = require("./constants");

var requestSecretList = function requestSecretList(parents, search) {
  return {
    type: _constants.secretListTypes.SECRET_LIST_REQUEST,
    payload: {
      parents: parents,
      search: search
    }
  };
};

exports.requestSecretList = requestSecretList;

var loadingSecretList = function loadingSecretList() {
  return {
    type: _constants.secretListTypes.SECRET_LIST_LOADING
  };
};

exports.loadingSecretList = loadingSecretList;

var successSecretList = function successSecretList(secretListData, secretListPagination) {
  return {
    type: _constants.secretListTypes.SECRET_LIST_SUCCESS,
    payload: {
      secretListData: secretListData,
      secretListPagination: secretListPagination
    }
  };
};

exports.successSecretList = successSecretList;

var failureSecretList = function failureSecretList(error) {
  return {
    type: _constants.secretListTypes.SECRET_LIST_FAILURE,
    payload: error
  };
};

exports.failureSecretList = failureSecretList;

var requestAuthenticateStepUpMFA = function requestAuthenticateStepUpMFA(factor, postBody) {
  return {
    type: _constants.AuthenticateStepUpMFATypes.SECRET_STEP_UP_MFA_REQUEST,
    payload: {
      factor: factor,
      postBody: postBody
    }
  };
};

exports.requestAuthenticateStepUpMFA = requestAuthenticateStepUpMFA;

var successStepUpMFA = function successStepUpMFA(data) {
  return {
    type: _constants.AuthenticateStepUpMFATypes.SECRET_STEP_UP_MFA_SUCCESS,
    payload: data
  };
};

exports.successStepUpMFA = successStepUpMFA;

var failureStepUpMFA = function failureStepUpMFA(payload) {
  return {
    type: _constants.AuthenticateStepUpMFATypes.SECRET_STEP_UP_MFA_FAILURE,
    payload: payload
  };
};

exports.failureStepUpMFA = failureStepUpMFA;

var flushStepUpMFA = function flushStepUpMFA() {
  return {
    type: _constants.AuthenticateStepUpMFATypes.SECRET_STEP_UP_MFA_FLUSH
  };
};

exports.flushStepUpMFA = flushStepUpMFA;

var requestSecretDetails = function requestSecretDetails(path, data) {
  return {
    type: _constants.SecretDetailsTypes.SECRET_DETAILS_REQUEST,
    payload: {
      path: path,
      data: data
    }
  };
};

exports.requestSecretDetails = requestSecretDetails;

var loadingSecretDetails = function loadingSecretDetails() {
  return {
    type: _constants.SecretDetailsTypes.SECRET_DETAILS_LOADING
  };
};

exports.loadingSecretDetails = loadingSecretDetails;

var successSecretDetails = function successSecretDetails(secretData) {
  return {
    type: _constants.SecretDetailsTypes.SECRET_DETAILS_SUCCESS,
    payload: secretData
  };
};

exports.successSecretDetails = successSecretDetails;

var failureSecretDetails = function failureSecretDetails(payload) {
  return {
    type: _constants.SecretDetailsTypes.SECRET_DETAILS_FAILURE,
    payload: payload
  };
};

exports.failureSecretDetails = failureSecretDetails;

var resetSecretDetails = function resetSecretDetails() {
  return {
    type: _constants.SecretDetailsTypes.SECRET_DETAILS_RESET
  };
};

exports.resetSecretDetails = resetSecretDetails;

var requestSecretListLoadMore = function requestSecretListLoadMore(parents) {
  return {
    type: _constants.secretListTypes.SECRET_LIST_LOAD_MORE_REQUEST,
    payload: {
      parents: parents
    }
  };
};

exports.requestSecretListLoadMore = requestSecretListLoadMore;

var loadingSecretListLoadMore = function loadingSecretListLoadMore() {
  return {
    type: _constants.secretListTypes.SECRET_LIST_LOAD_MORE_LOADING
  };
};

exports.loadingSecretListLoadMore = loadingSecretListLoadMore;

var successSecretListLoadMore = function successSecretListLoadMore(secretListData) {
  return {
    type: _constants.secretListTypes.SECRET_LIST_LOAD_MORE_SUCCESS,
    payload: secretListData
  };
};

exports.successSecretListLoadMore = successSecretListLoadMore;

var failureSecretListLoadMore = function failureSecretListLoadMore(error) {
  return {
    type: _constants.secretListTypes.SECRET_LIST_LOAD_MORE_FAILURE,
    payload: error
  };
};

exports.failureSecretListLoadMore = failureSecretListLoadMore;

var updateSecretListSearchTerm = function updateSecretListSearchTerm(search) {
  return {
    type: _constants.secretListTypes.SECRET_LIST_SEARCH_TERM_UPDATE,
    payload: search
  };
};

exports.updateSecretListSearchTerm = updateSecretListSearchTerm;

var requestSecretTemplateDetails = function requestSecretTemplateDetails(staticSecretTemplateId) {
  return {
    type: _constants.secretTemplateDetailsTypes.SECRET_TEMPLATE_DETAILS_REQUEST,
    payload: {
      id: staticSecretTemplateId
    }
  };
};

exports.requestSecretTemplateDetails = requestSecretTemplateDetails;

var loadingSecretTemplateDetails = function loadingSecretTemplateDetails() {
  return {
    type: _constants.secretTemplateDetailsTypes.SECRET_TEMPLATE_DETAILS_LOADING
  };
};

exports.loadingSecretTemplateDetails = loadingSecretTemplateDetails;

var successSecretTemplateDetails = function successSecretTemplateDetails(secretTemplateData) {
  return {
    type: _constants.secretTemplateDetailsTypes.SECRET_TEMPLATE_DETAILS_SUCCESS,
    payload: secretTemplateData
  };
};

exports.successSecretTemplateDetails = successSecretTemplateDetails;

var failureSecretTemplateDetails = function failureSecretTemplateDetails(error) {
  return {
    type: _constants.secretTemplateDetailsTypes.SECRET_TEMPLATE_DETAILS_FAILURE,
    payload: error
  };
};

exports.failureSecretTemplateDetails = failureSecretTemplateDetails;

var loadingUserDetails = function loadingUserDetails() {
  return {
    type: _constants.fetchUsersType.FETCH_USERS_LOADING_VIEW_SECRET
  };
};

exports.loadingUserDetails = loadingUserDetails;

var successUserDetails = function successUserDetails(userData) {
  return {
    type: _constants.fetchUsersType.FETCH_USERS_SUCCESS_VIEW_SECRET,
    payload: userData
  };
};

exports.successUserDetails = successUserDetails;

var failureUserDetails = function failureUserDetails(error) {
  return {
    type: _constants.fetchUsersType.FETCH_USERS_FAILURE_VIEW_SECRET,
    payload: error
  };
};

exports.failureUserDetails = failureUserDetails;

var resetUserDetails = function resetUserDetails() {
  return {
    type: _constants.fetchUsersType.FETCH_USERS_RESET_VIEW_SECRET
  };
};

exports.resetUserDetails = resetUserDetails;

var loadingGroupsDetails = function loadingGroupsDetails() {
  return {
    type: _constants.fetchGroupsType.FETCH_GROUPS_LOADING_VIEW_SECRET
  };
};

exports.loadingGroupsDetails = loadingGroupsDetails;

var successGroupsDetails = function successGroupsDetails(userData) {
  return {
    type: _constants.fetchGroupsType.FETCH_GROUPS_SUCCESS_VIEW_SECRET,
    payload: userData
  };
};

exports.successGroupsDetails = successGroupsDetails;

var failureGroupsDetails = function failureGroupsDetails(error) {
  return {
    type: _constants.fetchGroupsType.FETCH_GROUPS_FAILURE_VIEW_SECRET,
    payload: error
  };
};

exports.failureGroupsDetails = failureGroupsDetails;

var resetGroupsDetails = function resetGroupsDetails() {
  return {
    type: _constants.fetchGroupsType.FETCH_GROUPS_RESET_VIEW_SECRET
  };
};

exports.resetGroupsDetails = resetGroupsDetails;

var getSecretFileDownloadAction = function getSecretFileDownloadAction(parents, vaultId) {
  return {
    type: _constants.mySecretFileDownloadTypes.MY_SECRET_FILE_DOWNLOAD_REQUEST,
    payload: {
      parents: parents,
      vaultId: vaultId
    }
  };
};

exports.getSecretFileDownloadAction = getSecretFileDownloadAction;

var resetSecretFileDownload = function resetSecretFileDownload() {
  return {
    type: _constants.mySecretFileDownloadTypes.MY_SECRET_FILE_DOWNLOAD_RESET
  };
};

exports.resetSecretFileDownload = resetSecretFileDownload;

var getNewOTPAction = function getNewOTPAction(parents) {
  return {
    type: _constants.secretOTPTypes.SECRET_OTP_FETCH_REQUEST,
    payload: {
      parents: parents
    }
  };
};

exports.getNewOTPAction = getNewOTPAction;

var resetOTPAction = function resetOTPAction() {
  return {
    type: _commonConstants.RESOURCE_STATUS.INITIAL
  };
};

exports.resetOTPAction = resetOTPAction;

var startWebAuthnAuthentication = function startWebAuthnAuthentication() {
  return {
    type: _commonConstants.stepUpAuthenticationTypes.START_WEB_AUTHN_AUTHENTICATION_REQUEST
  };
};

exports.startWebAuthnAuthentication = startWebAuthnAuthentication;

var successStartWebAuthnAuthentication = function successStartWebAuthnAuthentication(data) {
  return {
    type: _commonConstants.stepUpAuthenticationTypes.START_WEB_AUTHN_AUTHENTICATION_SUCCESS,
    payload: data
  };
};

exports.successStartWebAuthnAuthentication = successStartWebAuthnAuthentication;

var failureStartWebAuthnAuthentication = function failureStartWebAuthnAuthentication(error) {
  return {
    type: _commonConstants.stepUpAuthenticationTypes.START_WEB_AUTHN_AUTHENTICATION_FAILURE,
    payload: error
  };
};

exports.failureStartWebAuthnAuthentication = failureStartWebAuthnAuthentication;

var loadingStartWebAuthnAuthentication = function loadingStartWebAuthnAuthentication() {
  return {
    type: _commonConstants.stepUpAuthenticationTypes.START_WEB_AUTHN_AUTHENTICATION_LOADING
  };
};

exports.loadingStartWebAuthnAuthentication = loadingStartWebAuthnAuthentication;

var resetStartWebAuthnAuthentication = function resetStartWebAuthnAuthentication() {
  return {
    type: _commonConstants.stepUpAuthenticationTypes.START_WEB_AUTHN_AUTHENTICATION_RESET
  };
};

exports.resetStartWebAuthnAuthentication = resetStartWebAuthnAuthentication;

var authenticateViaWebAuthN = function authenticateViaWebAuthN(webAuthnInitialData, publicKeyCredential) {
  return {
    type: _commonConstants.stepUpAuthenticationTypes.AUTHENTICATE_VIA_WEB_AUTHN_REQUEST,
    payload: {
      webAuthnInitialData: webAuthnInitialData,
      publicKeyCredential: publicKeyCredential
    }
  };
};

exports.authenticateViaWebAuthN = authenticateViaWebAuthN;

var fetchUserMFAStatus = function fetchUserMFAStatus() {
  return {
    type: _commonConstants.stepUpAuthenticationTypes.FETCH_USER_MFA_STATUS_REQUEST
  };
};

exports.fetchUserMFAStatus = fetchUserMFAStatus;

var successFetchUserMFAStatus = function successFetchUserMFAStatus(data) {
  return {
    type: _commonConstants.stepUpAuthenticationTypes.FETCH_USER_MFA_STATUS_SUCCESS,
    payload: data
  };
};

exports.successFetchUserMFAStatus = successFetchUserMFAStatus;

var failureFetchUserMFAStatus = function failureFetchUserMFAStatus(error) {
  return {
    type: _commonConstants.stepUpAuthenticationTypes.FETCH_USER_MFA_STATUS_FAILURE,
    payload: error
  };
};

exports.failureFetchUserMFAStatus = failureFetchUserMFAStatus;

var loadingFetchUserMFAStatus = function loadingFetchUserMFAStatus() {
  return {
    type: _commonConstants.stepUpAuthenticationTypes.FETCH_USER_MFA_STATUS_LOADING
  };
};

exports.loadingFetchUserMFAStatus = loadingFetchUserMFAStatus;

var resetFetchUserMFAStatus = function resetFetchUserMFAStatus() {
  return {
    type: _commonConstants.stepUpAuthenticationTypes.FETCH_USER_MFA_STATUS_RESET
  };
};

exports.resetFetchUserMFAStatus = resetFetchUserMFAStatus;